import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { usPhoneNumberValidation } from 'validators';
import { Button, USPhoneNumberInput } from 'seagull';
import PostalAddressForm from '~/components/PostalAddressForm/PostalAddressForm';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import { StepTemplate } from '../StepTemplate';
import { useQboInVob } from '../useQboInVob';
import { Step } from '../VendorOnboardingModal.utils';
import styles from './SecondStep.module.scss';
export function SecondStep(props) {
    var _initialState_postalAddress, _initialState_postalAddress1, _initialState_postalAddress2, _initialState_postalAddress3, _initialState_postalAddress4, _initialState_postalAddress5;
    const { initialState, onSubmit } = props;
    const defaultPostalAddress = {
        address1: (initialState === null || initialState === void 0 ? void 0 : (_initialState_postalAddress = initialState.postalAddress) === null || _initialState_postalAddress === void 0 ? void 0 : _initialState_postalAddress.address1) || '',
        address2: (initialState === null || initialState === void 0 ? void 0 : (_initialState_postalAddress1 = initialState.postalAddress) === null || _initialState_postalAddress1 === void 0 ? void 0 : _initialState_postalAddress1.address2) || '',
        city: (initialState === null || initialState === void 0 ? void 0 : (_initialState_postalAddress2 = initialState.postalAddress) === null || _initialState_postalAddress2 === void 0 ? void 0 : _initialState_postalAddress2.city) || '',
        state: (initialState === null || initialState === void 0 ? void 0 : (_initialState_postalAddress3 = initialState.postalAddress) === null || _initialState_postalAddress3 === void 0 ? void 0 : _initialState_postalAddress3.state) || '',
        postalCode: (initialState === null || initialState === void 0 ? void 0 : (_initialState_postalAddress4 = initialState.postalAddress) === null || _initialState_postalAddress4 === void 0 ? void 0 : _initialState_postalAddress4.postalCode) || '',
        country: (initialState === null || initialState === void 0 ? void 0 : (_initialState_postalAddress5 = initialState.postalAddress) === null || _initialState_postalAddress5 === void 0 ? void 0 : _initialState_postalAddress5.country) || 'US'
    };
    const methods = useForm({
        mode: 'onChange',
        defaultValues: {
            postalAddress: defaultPostalAddress,
            phone: (initialState === null || initialState === void 0 ? void 0 : initialState.phone) || ''
        }
    });
    const { showQboStep } = useQboInVob();
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, methods), {
        children: /*#__PURE__*/ _jsx("form", {
            onSubmit: methods.handleSubmit(onSubmit),
            children: /*#__PURE__*/ _jsx(StepTemplate, {
                currentStep: Step.Second,
                stepper: "Step 2 of ".concat(showQboStep ? '3' : '2'),
                header: "What’s your business address?",
                subHeader: "To ensure smooth payments, please add your business address",
                footer: /*#__PURE__*/ _jsx(Button, {
                    testId: "vob-step-".concat(Step.Second, "-submit"),
                    type: "submit",
                    children: showQboStep ? 'Continue' : 'Take me to my account'
                }),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.root,
                    children: [
                        /*#__PURE__*/ _jsx(Controller, {
                            control: methods.control,
                            name: "postalAddress",
                            render: (_renderProps)=>/*#__PURE__*/ _jsx(PostalAddressForm, {
                                    testId: "vob"
                                })
                        }),
                        /*#__PURE__*/ _jsx(Controller, {
                            control: methods.control,
                            name: "phone",
                            rules: usPhoneNumberValidation({
                                required: 'Please enter a phone number'
                            }),
                            render: (renderProps)=>/*#__PURE__*/ _jsx(USPhoneNumberInput, _object_spread_props(_object_spread({
                                    collapseHelperText: false
                                }, connectControllerToTextField(renderProps)), {
                                    testId: "vob-phone",
                                    label: "Your phone number"
                                }))
                        })
                    ]
                })
            })
        })
    }));
}
